import confetti from "canvas-confetti";

/**
 * Preset alineado con el playground de react-canvas-confetti
 * (particleCount, gravity, colors, scalar).
 * @see https://ulitcos.github.io/react-canvas-confetti/playground/
 */
const SLIDE_ENTER_CONFETTI = {
  particleCount: 2000,
  gravity: 3,
  colors: ["red", "orange"],
  scalar: 0.3,
  spread: 360,
  startVelocity: 35,
  origin: { x: 0.5, y: 0.4 },
};

export function onboardingPrefersReducedMotion() {
  if (typeof window === "undefined") return true;
  return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;
}

/** Ráfaga única al mostrar una diapositiva en la vista pública compartida. */
export function fireOnboardingSlideEnterConfetti() {
  if (typeof window === "undefined") return;
  if (onboardingPrefersReducedMotion()) return;
  try {
    confetti(SLIDE_ENTER_CONFETTI);
  } catch (_) {
    /* noop */
  }
}
